// window._ = require('lodash');

try {
    window.$ = window.jQuery = require('jquery');

    require('bootstrap-sass');
} catch (e) {
    //
}

require('es6-promise').polyfill();

window.Vue = require('vue');

window.axios = require('axios');

window.debounce = require('debounce');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = $('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.attr('content');

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': token.attr('content')
        }
    });
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

require('jquery-ui/ui/widgets/datepicker');

let lang = $('html').attr('lang'),
    datepicker_lang = lang === 'en' ? 'en-GB' : lang;

require('jquery-ui/ui/i18n/datepicker-' + datepicker_lang);

$.datepicker.setDefaults($.datepicker.regional[datepicker_lang]);

require('timepicker');

window.moment = require('moment');

window.moment.locale(lang);

require('intl-tel-input/build/js/intlTelInput');
require('intl-tel-input/build/js/utils');

require('lightgallery');

window.iziToast = require('izitoast');

require('slick-carousel');

require('jquery-plainoverlay');

window.MobileDetect = require('mobile-detect');

require('select2');
require('../select2translates/' + lang + '.js');

window.bootbox = require('bootbox');

require('../scripts.js');



// WEBPACK FOOTER //
// ./resources/assets/js/frontend/bootstrap.js